import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createTimeClock } from 'api/admin/timeClock/createTimeClock'
import { timeClockKeys } from './keys'

export function useCreateTimeClockMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createTimeClock,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: timeClockKeys.all })
    },
  })
}
